<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_spy_intro')
}

const isOnSpiesSection = computed(() => {
  return route.path.startsWith('/diplomacy/spies')
})

const goToSpies = () => {
  router.push('/diplomacy/spies')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/spy.webm"
  >
    <template #text>
      <p class="pb-2">
        We just trained our first spy!
      </p>
      <p class="pb-2">
        Spies allow you to steal resources and commit sabotage to other civilizations.
      </p>
      <p class="pb-2">
        Each spy starts out as a novice, and the more your train them or success they have with their missions, the more advanced and effective they are.
      </p>
      <p class="pb-2">
        Lets head over to the spy section.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Diplomacy" button in the top menu, then select "Spies".
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "Diplomacy" and "Spies".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnSpiesSection" @click="goToSpies" class="mr-2">
        Go to Spies
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Got it!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>